import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4a7a8ac4")
const _hoisted_1 = { class: "p-grid p-nogutter p-ai-center p-jc-between module-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-left p-mr-4 clickable" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Default title, use 'v-slot:title' or '#title'! ")
const _hoisted_6 = {
  key: 0,
  class: "p-col-7"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("h1", {
      class: _normalizeClass([!_ctx.$slots['right-content'] ? 'p-col-12': 'p-col-5'])
    }, [
      (_ctx.showGoBack)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
          }, _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.title), 1))
        : _renderSlot(_ctx.$slots, "title", { key: 2 }, () => [
            _hoisted_5
          ], {}, true)
    ], 2),
    (_ctx.$slots['right-content'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "right-content", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}